"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsAgentsInsightsWrapper$ = exports.StatsAgentsInsightsWrapper$outboundSchema = exports.StatsAgentsInsightsWrapper$inboundSchema = void 0;
exports.statsAgentsInsightsWrapperToJSON = statsAgentsInsightsWrapperToJSON;
exports.statsAgentsInsightsWrapperFromJSON = statsAgentsInsightsWrapperFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const statsagentsareainsightsattribute_js_1 = require("./statsagentsareainsightsattribute.js");
/** @internal */
exports.StatsAgentsInsightsWrapper$inboundSchema = z.object({
    attributes: statsagentsareainsightsattribute_js_1.StatsAgentsAreaInsightsAttribute$inboundSchema,
    id: z.string(),
    type: z.literal("agent_id").default("agent_id").optional(),
});
/** @internal */
exports.StatsAgentsInsightsWrapper$outboundSchema = z.object({
    attributes: statsagentsareainsightsattribute_js_1.StatsAgentsAreaInsightsAttribute$outboundSchema,
    id: z.string(),
    type: z.literal("agent_id").default("agent_id"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsAgentsInsightsWrapper$;
(function (StatsAgentsInsightsWrapper$) {
    /** @deprecated use `StatsAgentsInsightsWrapper$inboundSchema` instead. */
    StatsAgentsInsightsWrapper$.inboundSchema = exports.StatsAgentsInsightsWrapper$inboundSchema;
    /** @deprecated use `StatsAgentsInsightsWrapper$outboundSchema` instead. */
    StatsAgentsInsightsWrapper$.outboundSchema = exports.StatsAgentsInsightsWrapper$outboundSchema;
})(StatsAgentsInsightsWrapper$ || (exports.StatsAgentsInsightsWrapper$ = StatsAgentsInsightsWrapper$ = {}));
function statsAgentsInsightsWrapperToJSON(statsAgentsInsightsWrapper) {
    return JSON.stringify(exports.StatsAgentsInsightsWrapper$outboundSchema.parse(statsAgentsInsightsWrapper));
}
function statsAgentsInsightsWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsAgentsInsightsWrapper$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsAgentsInsightsWrapper' from JSON`);
}
//# sourceMappingURL=statsagentsinsightswrapper.js.map